import { deleteInvitation } from '@/store/module/team/mutation/deleteInvitation.js';
import { setInvitations } from '@/store/module/team/mutation/setInvitations.js';
import { setMembers } from '@/store/module/team/mutation/setMembers.js';

export const mutations = {
	deleteInvitation,
	setInvitations,
	setMembers
};
